import type { LoaderFunction } from 'react-router';

import { FEATURED_THREADS_PAGE_SIZE } from 'src/core/domain/constants';
import { getAuthStatus } from 'src/core/utils/authUtil';
import { getCurrentPageNumber } from 'src/core/utils/pageUtil';
import logger from 'src/modules/logger/logger';
import {
  fetchFeaturedThreads,
  type fetchFeaturedThreadsParams,
} from 'src/services/threadsService';
import type { RouteProps } from 'src/types';

export const communityHomeLoader =
  ({ config, client }: RouteProps): LoaderFunction =>
  async () => {
    try {
      const isServer = typeof window === 'undefined';
      const isAuthenticated = await getAuthStatus();
      const pageNumber = getCurrentPageNumber(config);

      const params: fetchFeaturedThreadsParams = {
        cursor: (pageNumber - 1) * FEATURED_THREADS_PAGE_SIZE,
        isAuthenticated,
        client,
        config,
      };
      const featuredThreads = await fetchFeaturedThreads(params);

      return {
        featuredThreads,
        pageNumber,
        isAuthenticated,
        isServer,
        init: true,
      };
    } catch (error) {
      logger.error({ error }, 'communityHomeLoader');
      throw error;
    }
  };
